import { FilterOverride, QuickFiltersOverride } from 'config/wls/wlConfig';
import {
  QuickFilterConfig,
 
} from 'types/QuickFilters';


function insertFilter(
  filters: QuickFilterConfig[],
  filter: QuickFilterConfig,
  options?: {
    after?: string;
    before?: string;
  }
) {
  const result = [...filters];

  if (options?.after) {
    const index = result.findIndex(
      (item) => item.filterId === options.after
    );

    if (index !== -1) {
      result.splice(index + 1, 0, filter);
      return result;
    }
  }

  if (options?.before) {
    const index = result.findIndex(
      (item) => item.filterId === options.before
    );

    if (index !== -1) {
      result.splice(index, 0, filter);
      return result;
    }
  }

  result.push(filter);

  return result;
}

function applyFilterOverride(
  filter: QuickFilterConfig,
  override: FilterOverride
): QuickFilterConfig {
  let result = {
    ...filter,
  };

  // patch config
  if (override.patch) {
    result = {
      ...result,
      ...override.patch,
    };
  }

  // patch list
  if (override.list && result.list) {
    let list = [...result.list];

    // remove list items
    if (override.list.remove) {
      list = list.filter(
        (item) =>
          !override.list?.remove?.includes(item.id)
      );
    }

    // add list items
    if (override.list.add) {
      list.push(...override.list.add);
    }

    result.list = list;
  }

  return result;
}

export function buildQuickFilters(
  defaultFilters: QuickFilterConfig[],
  overrides?: QuickFiltersOverride,
  page?: string
): QuickFilterConfig[] {
  if (!overrides || !page) {
    return defaultFilters;
  }

  const pageOverrides = overrides[page];

  if (!pageOverrides) {
    return defaultFilters;
  }

  let result = structuredClone(defaultFilters);

  // apply existing filter overrides
  result = result
    .filter((filter) => {
      const override =
        pageOverrides[filter.filterId];

      return !override?.hidden;
    })
    .map((filter) => {
      const override =
        pageOverrides[filter.filterId];

      if (!override) {
        return filter;
      }

      return applyFilterOverride(
        filter,
        override
      );
    });

  // add new filters
  Object.entries(pageOverrides).forEach(
    ([filterId, override]) => {
      if (!override.add) {
        return;
      }

      const alreadyExists = result.some(
        (filter) => filter.filterId === filterId
      );

      if (alreadyExists) {
        return;
      }

      result = insertFilter(
        result,
        override.add,
        {
          after: override.after,
          before: override.before,
        }
      );
    }
  );

  return result;
}